import React, { FC } from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import withComponentRefresh from '../../../../utils/aem/editor/withComponentRefresh'
import { EditableComponentPropsType } from '../../../../utils/prop-types'
import StoreMapFilterEditConfig, {
  StoreFilterProps
} from './StoreMapFilterEditConfig'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../../functional/ErrorBoundary'

const StoreMapFilter: FC<EditableComponentPropsType<StoreFilterProps>> =
  withComponentRefresh((props) => {
    const editableProps = { ...props }
    const isAuthor = AuthoringUtils.isInEditor()

    if (!isAuthor) {
      return null
    }

    // In author mode, show a simple placeholder
    return (
      <EditableComponent {...editableProps}>
        {StoreMapFilterEditConfig.configLabel}
      </EditableComponent>
    )
  })

const StoreMapFilterWithErrorBoundary = withErrorBoundary(StoreMapFilter, {
  componentName: 'StoreMapFilter',
  fallback: <ErrorFallback componentName="StoreMapFilter" />
})

export default StoreMapFilterWithErrorBoundary
